











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { Trade } from '@/models/trade';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'TradesList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class TradesList extends Vue {
    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    @Prop() private trades: Trade[];
    @Prop() private searchQuery: string;
    @Prop() private isLoading: boolean;

    @Getter('account/userInfo') private userInfo: User;

    private rowClicked(row) {
        this.$emit('rowClicked', row);
    }
}
